module.exports = __webpack_public_path__ + "static/img/014.a6ae8812.png";